import React from "react";
import PropTypes from "prop-types";
import "./styles/MessageBot.css";

let MessageBot = ({
  placeholder,
  userMessage,
  handleChange,
  sendUserMessage
}) => {
  return (
    <form
      className="MessageBot"
      autoComplete="off"
      onSubmit={sendUserMessage.bind(this)}
    >
      <input
        className="MessageBot-input"
        required
        type="text"
        placeholder={placeholder}
        name="userMessage"
        value={userMessage}
        onChange={handleChange.bind(this)}
      />
      <button type="submit" className="fa fa-paper-plane MessageBot-button" />
    </form>
  );
};

MessageBot.propTypes = {
  placeholder: PropTypes.string.isRequired,
  userMessage: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  sendUserMessage: PropTypes.func.isRequired
};

export default MessageBot;



// WEBPACK FOOTER //
// ./src/modules/MessageBot.js